<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <router-link to="/principal" style="text-decoration: none">
        <img
          src="img/logo1.png"
          width="45"
          alt=""
          class="d-inline-block align-middle mr-2"
        />
      </router-link>
    </div>
    <button
      @click="toggleNavbar"
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navigation"
      aria-controls="navigation-index"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu" v-if="this.$store.state.loggedIn">
      <router-link class="nav-item" tag="li" to="/add-by-part-number">
        <a class="nav-link top-link">
          {{ $t("app.modules.add_by_part_number.title") }}
        </a>
      </router-link>

      <!--
      <li class="nav-item">
        <a href="#" class="nav-link top-link" @click="showOrderByFileUpload">
          {{ $t("app.modules.order_by_file_upload.title") }}
        </a>
      </li>-->

      <router-link class="nav-item" tag="li" to="/add-by-excel">
        <a class="nav-link top-link">
          {{ $t("app.modules.order_by_file_upload.title") }}
        </a>
      </router-link>

      <!--
      <verify-permission controller="FamiliasProducto" action="getFamiliaProductoByCategoria">
        <router-link class="nav-item" tag="li" to="/catalogo_productos">
          <a class="nav-link top-link">
            {{ $t("app.nav_bar.admin.options.product_catalog") }}
          </a>
        </router-link>
      </verify-permission>
      -->

      <!--
      <verify-permission controller="EstadoCuenta" action="processEstadosCuenta">
        <router-link class="nav-item" tag="li" to="/mis_estados_cuenta">
          <a class="nav-link top-link">
            {{ $t("app.nav_bar.admin.options.account") }}
          </a>
        </router-link>
      </verify-permission>

      <verify-permission controller="FacturacionCliente" action="getFacturasCliente">
        <router-link class="nav-item" tag="li" to="/mis_facturas">
          <a class="nav-link top-link">
            {{ $t("app.nav_bar.admin.options.billing") }}
          </a>
        </router-link>
      </verify-permission>
      -->

      <!--
      <verify-permission controller="Reclamaciones" action="getReclamacionesByCliente">
        <router-link class="nav-item" tag="li" to="/reclamaciones">
          <a class="nav-link top-link">
            {{ $t("app.nav_bar.admin.options.claims") }}
          </a>
        </router-link>
      </verify-permission>

      <verify-permission controller="Pedidos" action="pedidosModeloByUser">
        <router-link class="nav-item" tag="li" to="/pedidos_modelo">
          <a class="nav-link top-link">
            {{ $t("app.nav_bar.admin.options.model_order") }}
          </a>
        </router-link>
      </verify-permission>
      -->

      <verify-permission
        controller="Pedidos"
        action="listaPedidosWebWithProductoCliente"
      >
        <router-link class="nav-item" tag="li" to="/mis_pedidos">
          <a class="nav-link top-link">
            {{ $t("app.nav_bar.admin.options.my_orders") }}
          </a>
        </router-link>
      </verify-permission>

      <verify-permission
        controller="BackOrder"
        action="getBackOrder"
      >
        <router-link class="nav-item" tag="li" to="/reporte/back-order">
          <a class="nav-link top-link">
            {{ $t("app.modules.reports.back_order") }}
          </a>
        </router-link>
      </verify-permission>

      <verify-permission
        controller="EstadoCuenta"
        action="getEC"
      >
      <router-link class="nav-item" tag="li" to="/reporte/open-invoices">
        <a class="nav-link top-link">
          {{ $t("app.modules.reports.open_invoices") }}
        </a>
      </router-link>
      </verify-permission>

      <!--

      <verify-permission controller="Pedidos" action="getUltimosProductosAdquiridosWeb">
        <router-link class="nav-item" tag="li" to="/compras_recientes">
          <a class="nav-link top-link">
            {{ $t("app.general.recent_purchase") }}
          </a>
        </router-link>
      </verify-permission>
      -->

      <ul class="navbar-nav">
        <verify-permission controller="Cart" action="getCartItems">
          <drop-down
            tag="li"
            position="right"
            class="nav-item"
            icon="now-ui-icons shopping_cart-simple"
            :value="cartCount"
          >
            <h6 class="dropdown-header text-center" style="min-width: 300px">
              {{ $t("app.cart.title") }}
            </h6>
            <cart-list :is-drop-down="true" ref="list"></cart-list>
            <router-link
              class="nav-item text-center"
              tag="li"
              to="/cart_pedido_page"
            >
              <a class="nav-link">
                {{ $t("app.cart.showCart") }}
              </a>
            </router-link>
          </drop-down>
        </verify-permission>
        
        <!--
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons location_world"
          :title="' | ' + this.$store.state.lang"
        >
          <button class="dropdown-item" @click="changeLanguage('es')">
            {{ $t("app.languages.spanish") }}
          </button>
          <button class="dropdown-item" @click="changeLanguage('en')">
            {{ $t("app.languages.english") }}
          </button>
        </drop-down>
        -->
        
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons users_single-02"
          :title="$t('app.nav_bar.admin.account.title')"
        >
          <a class="dropdown-item" href="#" @click="showProfile">
            <i class="now-ui-icons business_badge"></i>
            &nbsp;{{ $t("app.profile.title") }}<br />
          </a>

          <a class="dropdown-item" href="#" @click="showConfig">
            <i class="now-ui-icons loader_gear"></i>
            &nbsp;{{ $t("app.general.preferences") }}<br />
          </a>
          <a class="dropdown-item" href="#" @click="exit">
            <i class="now-ui-icons arrows-1_share-66"></i>
            &nbsp;{{ $t("app.nav_bar.admin.account.close_session") }}<br />
          </a>
          <!--<a class="dropdown-item" href="{{  }}">Cerrar sesión</a>-->
          <!--<a class="dropdown-item" @click="closeSesion" href="#/logout">{{
            $t("app.nav_bar.admin.account.close_session")
          }}</a>-->
        </drop-down>
        <!--<chat-form />-->
        <el-link :underline="false" @click="showNotification">
          <el-badge v-if="this.nc" :value="this.nc">
            <i class="now-ui-icons ui-1_bell-53"></i>
          </el-badge>
          <el-badge v-else>
            <i class="now-ui-icons ui-1_bell-53"></i>
          </el-badge>
        </el-link>
      </ul>
    </template>
    <template slot="navbar-menu" v-else>
      <ul class="navbar-nav">
        <router-link class="nav-item" tag="li" to="#">
          <a class="nav-link" @click="openSession">
            {{ $t("app.nav_bar.admin.account.open_session") }}
          </a>
        </router-link>
      </ul>
    </template>
    <cart-modal></cart-modal>
    <profile />
    <notificaciones />
    <order-by-file-upload />
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components";
import { mapState, mapMutations } from "vuex";
import CartList from "@/pages/views/web/cart/cartList";

export default {
  components: {
    CartList,
    Navbar,
    //CartModal: () => import("../../views/web/cart/cartModal.vue"),
    Profile: () => import("../../views/web/components/profile"),
    Notificaciones: () => import("../../views/web/components/notificaciones"),
    //ChatForm: () => import("../../views/web/components/chatForm"),
    OrderByFileUpload: () =>
      import("../../views/web/components/addOrderByExcelUpload"),
  },
  computed: {
    ...mapState(["lang"]),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    cartCount() {
      if (this.list) {
        if (this.list.cartItems.length > 99) {
          return "+99";
        }
        if (this.list.cartItems.length) {
          return this.list.cartItems.length.toString();
        }
      }
      return "0";
    },
    nc() {
      return this.$store.state.not_count;
    },
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
      list: undefined,
    };
  },
  mounted() {
    this.list = this.$refs.list;
  },
  updated() {
    this.list = this.$refs.list;
  },
  methods: {
    ...mapMutations({
      setLang: "SET_LANG",
    }),
    changeLanguage(value) {
      this.$router.go(0);
      this.setLang(value);
      this.$root.$i18n.locale = value;
      this.changeChatLang(value == "es" ? "spanish" : "english");
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    closeSesion() {
      this.$router.push({
        name: "Logout",
      });
    },
    openSession() {
      this.$router.push({
        name: "Login",
      });
    },
    showCart() {
      EventBus.$emit("show-cart");
    },
    showProfile() {
      EventBus.$emit("show-profile");
    },
    showConfig() {
      this.$router.push({
        name: "Configurar web",
      });
    },
    showNotification() {
      
      EventBus.$emit("show-notification");
    },
    exit() {
      this.$router.push({
        name: "Logout",
      });
    },
    async changeChatLang(lang) {
      await this.$http
        .get(process.env.VUE_APP_CHAT_ENDPOINT + "/language/" + lang)
        .then(
          (response) => {
            // console.log(response);
            if (response.status == 200) {
              this.messages.push({
                origin: "bot",
                message: response.body,
              });
              container.scrollTop = container.scrollHeight;
            }
          },
          (error) => {
            console.error(error);
          }
        );
    },
    showOrderByFileUpload() {
      console.log("Entra a showOrderByFileUpload");
      EventBus.$emit("show-add-by-fileupload");
    },
  },
  created() {
    //console.log(this.nc);
    //console.log(this.$store.state.not_count);
  },
};
</script>

<style scoped>
.el-badge__content.is-fixed {
  top: 10px !important;
  right: 15px !important;
}
@media screen and (min-width: 1440px) {
  .top-link {
    font-size: 1em !important;
  }
}
@media screen and (min-width: 1080px) {
  .top-link {
    font-size: 0.9em !important;
  }
}

@media screen and (min-width: 992px) {
  .top-link {
    font-size: 0.7em !important;
  }
}
</style>
